<template>
	<div class="b-overlay-wrap position-relative">
		<button
			class="d-block btn h-100 text-nowrap"
			:class="btnClass"
			type="submit"
			:disabled="loading || disabled"
			@click="click"
			:aria-disabled="disabled"
		>
			<slot>
				<i v-if="icon" :class="`fa fa-fw ${icon} fa-sm`" />
				<span v-if="text" :class="{ 'ms-1': !!icon }">{{ text }}</span>
			</slot>
		</button>
		<div v-if="loading" class="b-overlay position-absolute" style="inset: 0px; z-index: 100">
			<div
				class="position-absolute bg-light rounded-sm"
				style="inset: 0px; opacity: 0.85; backdrop-filter: blur(2px)"
			></div>
			<div class="position-absolute" style="top: 50%; left: 50%; transform: translateX(-50%) translateY(-50%)">
				<span aria-hidden="true" class="spinner-border spinner-border-sm text-primary"></span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const loading = ref(false)

const props = defineProps<{
	callback: (() => Promise<unknown> | undefined) | Promise<unknown> | undefined; // The undefined here is used to simplyfy the usage of the component
	icon?: string;
	text?: string;
	btnClass?: string | string[] | Record<string, boolean>;
	btnStyle?: Record<string, string>;
	disabled?: boolean;
}>();

function click() {
	const promise: Promise<unknown> | undefined =
		typeof props.callback === 'function' ? props.callback() : props.callback;
	if (promise) {
		loading.value = true;
		promise /*.catch((error) => {
      console.error(error);
    })*/
			.finally(() => {
				loading.value = false;
			});
	} else {
		// Todo: Add propper error handling
		console.warn('No callback provided');
	}
}
</script>

<style lang="scss">
.input-group .b-overlay-wrap:not(:first-child) {
  button.btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
  }
}

.input-group .b-overlay-wrap:not(:last-child) {
  button.btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>